/**
 * iter70 — Branded KBRJ footer for the public gallery. Contact + social so
 * guests can easily reach the studio. Rendered above the mobile action bar
 * (with bottom padding on mobile to clear the fixed bar).
 */
import { Instagram, Phone, Mail, MapPin } from "lucide-react";

const STUDIO = {
  name: "Kahani by Rakesh Janardan",
  tagline: "Weddings, portraits & the moments between",
  // iter111 — Updated to the official studio contact number. Was
  // +91 98330 06070 (Rakesh's personal). WhatsApp deep-links use the
  // digits-only form; `displayPhone` renders on the tracker footer.
  whatsapp: "918055502966",
  displayPhone: "+91 80555 02966",
  email: "hello@kahanibyrakeshjanardan.com",
  instagram: "kahanibyrakeshjanardan",
  city: "Mumbai, India",
};

export default function KBRJFooter({ withMobileBarPadding = true }) {
  return (
    <footer
      className="border-t border-stone-200 bg-stone-50 mt-16"
      style={withMobileBarPadding ? { paddingBottom: "calc(env(safe-area-inset-bottom) + 72px)" } : {}}
      data-testid="kbrj-footer"
    >
      <div className="max-w-4xl mx-auto px-5 py-10 sm:py-14">
        <div className="grid gap-8 sm:grid-cols-3">
          <div className="sm:col-span-2">
            <div className="text-[10px] font-semibold tracking-[0.3em] uppercase text-rose-700">
              Studio
            </div>
            <h4 className="mt-1 font-heading text-xl sm:text-2xl font-semibold text-stone-900">
              {STUDIO.name}
            </h4>
            <p className="mt-2 text-sm text-stone-600 max-w-md">{STUDIO.tagline}</p>
            <p className="mt-3 text-xs text-stone-500 inline-flex items-center gap-1.5">
              <MapPin className="w-3.5 h-3.5" strokeWidth={1.6} />
              {STUDIO.city}
            </p>
          </div>

          <div>
            <div className="text-[10px] font-semibold tracking-[0.3em] uppercase text-rose-700">
              Get in touch
            </div>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <a
                  href={`https://wa.me/${STUDIO.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-stone-700 hover:text-rose-700"
                  data-testid="footer-whatsapp"
                >
                  <Phone className="w-4 h-4" strokeWidth={1.6} />
                  {STUDIO.displayPhone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${STUDIO.email}`}
                  className="inline-flex items-center gap-2 text-stone-700 hover:text-rose-700"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4" strokeWidth={1.6} />
                  {STUDIO.email}
                </a>
              </li>
              <li>
                <a
                  href={`https://instagram.com/${STUDIO.instagram}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-stone-700 hover:text-rose-700"
                  data-testid="footer-instagram"
                >
                  <Instagram className="w-4 h-4" strokeWidth={1.6} />
                  @{STUDIO.instagram}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-stone-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-[11px] text-stone-400">
          <span>© {new Date().getFullYear()} {STUDIO.name}. Every photograph, hand-picked.</span>
          <span className="tracking-[0.25em] uppercase">KBRJ · Studio Manager</span>
        </div>
      </div>
    </footer>
  );
}
